import React, { useEffect } from 'react';

const TermsOfService = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
 
  return (
    <div className="min-h-screen bg-white py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-bold text-slate-900 mb-8">Terms of Service</h1>
        <div className="prose prose-lg max-w-none space-y-6 text-gray-700">
          

          <section className="space-y-4">
            <h2 className="text-2xl font-bold text-slate-900 mt-8">1. Acceptance of Terms</h2>
            <p>
              By accessing and using the Trademark Resolutions website and services, you accept and agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-bold text-slate-900 mt-8">2. Services Provided</h2>
            <p>
              Trademark Resolutions provides trademark registration and related intellectual property services. Our services include but are not limited to:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Trademark searches and clearance</li>
              <li>Trademark application preparation and filing</li>
              <li>USPTO correspondence and office action responses</li>
              <li>Trademark monitoring and enforcement support</li>
              <li>Related intellectual property services</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-bold text-slate-900 mt-8">3. Legal Representation Disclaimer</h2>
            <p>
              Trademark Resolutions is a trademark filing service. We are not a law firm and do not provide legal advice. Our services are limited to document preparation and filing assistance. For legal advice, please consult with a licensed attorney.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-bold text-slate-900 mt-8">4. User Responsibilities</h2>
            <p>You agree to:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Provide accurate and complete information</li>
              <li>Have the legal right to register the trademark</li>
              <li>Use your trademark in commerce as required by law</li>
              <li>Respond promptly to our communications</li>
              <li>Comply with all applicable laws and regulations</li>
              <li>Pay all fees when due</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-bold text-slate-900 mt-8">5. Fees and Payment</h2>
            <p>
              Service fees are as listed on our website and are subject to change. Government filing fees are separate and paid directly to the USPTO. All fees are non-refundable once work has commenced, except as otherwise specified in writing.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-bold text-slate-900 mt-8">6. No Guarantee of Registration</h2>
            <p>
              While we strive for success, we cannot guarantee that the USPTO will approve your trademark application. Registration is ultimately at the discretion of the USPTO examining attorney. We are not responsible for USPTO refusals or rejections.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-bold text-slate-900 mt-8">7. Intellectual Property</h2>
            <p>
              All content on our website, including text, graphics, logos, and software, is the property of Trademark Resolutions or its licensors and is protected by copyright and other intellectual property laws.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-bold text-slate-900 mt-8">8. Limitation of Liability</h2>
            <p>
              To the fullest extent permitted by law, Trademark Resolutions shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of our services. Our total liability shall not exceed the amount paid by you for our services.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-bold text-slate-900 mt-8">9. Indemnification</h2>
            <p>
              You agree to indemnify and hold Trademark Resolutions harmless from any claims, damages, or expenses arising from your use of our services, your violation of these terms, or your violation of any rights of another party.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-bold text-slate-900 mt-8">10. Privacy</h2>
            <p>
              Your use of our services is also governed by our Privacy Policy. Please review our Privacy Policy to understand our practices regarding the collection and use of your information.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-bold text-slate-900 mt-8">11. Dispute Resolution</h2>
            <p>
              Any disputes arising from these terms or your use of our services shall be resolved through binding arbitration in accordance with the rules of the American Arbitration Association. You waive your right to participate in class actions.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-bold text-slate-900 mt-8">12. Governing Law</h2>
            <p>
              These Terms of Service shall be governed by and construed in accordance with the laws of the United States and the state in which our principal office is located, without regard to conflict of law principles.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-bold text-slate-900 mt-8">13. Changes to Terms</h2>
            <p>
              We reserve the right to modify these Terms of Service at any time. Changes will be effective immediately upon posting to our website. Your continued use of our services after changes are posted constitutes acceptance of the modified terms.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-bold text-slate-900 mt-8">14. Termination</h2>
            <p>
              We reserve the right to terminate or suspend your access to our services at any time, with or without cause, with or without notice.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-bold text-slate-900 mt-8">15. Severability</h2>
            <p>
              If any provision of these Terms of Service is found to be unenforceable or invalid, that provision shall be limited or eliminated to the minimum extent necessary, and the remaining provisions shall remain in full force and effect.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-bold text-slate-900 mt-8">16. Contact Information</h2>
            <p>
              If you have any questions about these Terms of Service, please contact us through our website or use the contact information provided on our contact page.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;